import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TASKS_PAGE_PARAM } from './taskFilterOptions';

/**
 * The single writer for a Tasks-page change that alters the result set: search,
 * filters and sort. An empty value removes the param. The page goes in the same
 * write, so no request runs for the old page under the new list.
 *
 * Every change is one `setSearchParams` call: two calls in the same flush both
 * start from the same base, and the second drops the first.
 */
export const useWriteTaskParams = () => {
  const [, setSearchParams] = useSearchParams();

  return useCallback(
    (updates: Record<string, string>) =>
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);

          Object.entries(updates).forEach(([key, value]) =>
            value ? next.set(key, value) : next.delete(key),
          );

          next.delete(TASKS_PAGE_PARAM);

          return next;
        },
        { replace: true },
      ),
    [setSearchParams],
  );
};
